// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3WKZ4","left":"styles_left__38SgM","desktopActions":"styles_desktopActions__2TXoq","title":"styles_title__1HgHU"};